import { SimIconType } from './sim-icon.data';

/** File-type icons keyed by file extension (lowercase, without the dot). */
const FILE_EXTENSION_ICONS: Record<string, SimIconType> = {
  pdf: 'documents_file_pdf',
  doc: 'documents_file_doc',
  docx: 'documents_file_doc',
  xls: 'documents_file_xls',
  xlsx: 'documents_file_xls',
  tif: 'documents_file_tiff',
  tiff: 'documents_file_tiff'
};

/** Icon matching the file's extension (PDF, Word, Excel, TIFF); `null` when there is no dedicated icon. */
export function documentFileIcon(fileName: string | null | undefined): SimIconType | null {
  const extension = fileName?.split('.').pop()?.toLowerCase() ?? '';
  return FILE_EXTENSION_ICONS[extension] ?? null;
}
